import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'UnauthorizedComponent',
	loadComponent: () => import('./UnauthorizedComponent.js' /* webpackChunkName: "UnauthorizedComponent" */),
}

export default entry
